import axios from "axios";
import React, { useEffect, useState } from "react";
import "./ListApplication.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { applicationReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

const ListApplication = () => {
  //Multi product one
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [productUnderApp, setProductUnderApp] = useState([]);
  const [productAddValues, setProductAddValues] = useState([]);
  const [productIdArr, setProductIdArr] = useState([]);
  // dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  //application edit related selectors
  // const application_id = useSelector(
  //   (state) => state.application.application_id
  // );
  const application_name = useSelector(
    (state) => state.application.application_name
  );
  const application_provider = useSelector(
    (state) => state.application.application_provider
  );
  const application_description = useSelector(
    (state) => state.application.application_description
  );
  const application_OS = useSelector(
    (state) => state.application.application_OS
  );
  const applicationstatus = useSelector(
    (state) => state.application.application_status
  );
  const application_bu = useSelector(
    (state) => state.application.application_bu
  );
  const application_division = useSelector(
    (state) => state.application.application_division
  );

  //Add Application and Edit Application related selectors
  const application_edit = useSelector(
    (state) => state.application.application_edit
  );
  const application_IsPane = useSelector(
    (state) => state.application.applicationIsPane
  );
  const addapplication_IsPane = useSelector(
    (state) => state.application.addapplicationIsPane
  );

  //state hook for listApplication  API's
  const [ListApp, setListApp] = useState([]);
  const [AppCount, setAppCount] = useState(null);
  const [divisionData, setdivisionData] = useState([]);
  const [buData, setBuData] = useState([]);

  //state hook for Add App API's
  const [newApplication, setNewApplication] = useState(null);
  const [newProvider, setNewProvider] = useState(null);
  const [newDescription, setNewDescription] = useState(null);
  const [newAppOS, setAppOS] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [newDivisionId, setNewDivisionId] = useState(null);

  //state hook for Edit App  API's
  const [applicationId, setApplicationId] = useState(null);
  const [applicationName, setApplicationName] = useState(null);
  const [applicationProvider, setApplicationProvider] = useState(null);
  const [appDescription, setApplicationDescription] = useState("");
  const [appOS, setApplicationOS] = useState(null);
  const [appStatus, setApplicationStatus] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState(null);
  const [divisionName, setDivisionName] = useState("");
  const [businessunitName, setBusinessunitName] = useState("");
  const [businessunitData, setBusinessunitData] = useState("");
  // const [tableheight, settableheight] = useState(false);

  // for filtering
  const [AppFilter, setAppFilter] = useState("");
  const [AppselData, setAppselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyAppfilter, setDummyAppfilter] = useState("");
  const [dummyAppselData, setDummyselData] = useState("");

  const application_filter = useSelector(
    (state) => state.application.application_filter
  );
  const bu_edit = useSelector((state) => state.application.bu_edit);

  //permissions
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  // const Download_Permission = useSelector(
  //   (state) => state.AccessTocken.Download_Permission
  // );

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // height: 300,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  //Header for API's
  const options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, AppselData, AppFilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, AppselData, AppFilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, AppselData, AppFilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, AppselData, AppFilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      // dispatch(sidebarReducer.apiLoad(true));
      setPageSelected(pageNo);
      setListApp([]);

      await axios
        .get(`applications/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            setListApp(response.data.data.rows);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);

      if (!isFilterIReset) {
        // dispatch(sidebarReducer.apiLoad(true));
        if (TargetColomn === "te_appstatus") {
          let status = AppFilter.toLowerCase();

          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        }
        await axios
          .get(
            `applications/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              // dispatch(sidebarReducer.apiLoad(false));
              setListApp(response.data.data.rows);
            } else if (response.status !== 200) {
              // dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            // dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        // dispatch(sidebarReducer.apiLoad(true));
        if (dummyAppfilter === "te_appstatuss") {
          let status = dummyAppfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
            // setDivfilter("1");
          } else if (status === "inactive") {
            keyWord = "0";
            // setDivfilter("0");
          }
        } else if (dummyAppselData !== "te_appstatus") {
          keyWord = dummyAppfilter;
        }
        await axios
          .get(
            `applications/list/?page=${pageNo}&limit=${listLimit}&${dummyAppselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              //dispatch(sidebarReducer.apiLoad(false));
              setListApp(response.data.data.rows);
            } else if (response.status !== 200) {
              //dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            // dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };

  async function responseData() {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`applications/list?page=${pageSelected}&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
          setAppCount(response.data.data.count);
          setListApp(response.data.data.rows);
          dispatch(sidebarReducer.apiLoad(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    await axios
      .get(`businessunit/listactive`, options)
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data.data, "resp");
          // dispatch(sidebarReducer.apiLoad(false));
          setBuData(response.data.data);
          //setBuData(buData);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  // division response for Division Dropdown
  async function DivisionResponse(opt) {
    //setApiLaod(true);
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/listactive/${opt}`, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          return setdivisionData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
      });
  }

  //Add Application API
  const newAddApplication_data = {
    applicationName: newApplication,
    applicationProvider: newProvider,
    applicationDescription: newDescription,
    applicationStatus: newStatus,
    appOs: newAppOS,
    divisionid: newDivisionId,
    productArray: productIdArr,
  };

  const onAddapplication = async (e) => {
    e.preventDefault();
    // dispatch(sidebarReducer.apiLoad(true));

    await axios
      .post("applications/create", newAddApplication_data, options)
      .then((response) => {
        if (response.status === 200) {
          //dispatch(sidebarReducer.apiLoad(false));
          setProductIdArr([]);
          setProductUnderApp([]);
          if (
            response.data.message ===
            `Application name '${newAddApplication_data.applicationName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }

          dispatch(applicationReducer.addapplication_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Update application API
  const newApplication_data = {
    applicationId: applicationId,
    applicationName: applicationName,
    applicationProvider: applicationProvider,
    applicationDescription: appDescription,
    applicationStatus: appStatus,
    appOs: appOS,
    divisionid: editDivisionId,
    productArray: productIdArr,
  };

  const onUpdate = async (applicationId) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`applications/update/${applicationId}`, newApplication_data, options)
      .then((response) => {
        if (response.status === 200) {
          setProductIdArr([]);
          setProductUnderApp([]);
          // dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Application name '${newApplication_data.applicationName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.update_success(true));
          }

          // Application name 'App1' already exists
          dispatch(applicationReducer.application_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListApplication"));
          dispatch(applicationReducer.application_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const onDelete = async (applicationId) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .delete(`applications/delete/${applicationId}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(applicationReducer.application_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListApplication"));
          dispatch(applicationReducer.application_IsPane(false));
          dispatch(sidebarReducer.delete_success(true));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
          dispatch(sidebarReducer.success(false));
          dispatch(sidebarReducer.failure(true));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Select an application from the table to get the pop up
  async function onEdit(item) {
    setApplicationId(item.te_application_id);
    setApplicationName(item.te_application_name);
    setApplicationProvider(item.te_app_provider);
    setApplicationDescription(item.te_appdescription);
    setApplicationOS(item.te_appos);
    setApplicationStatus(item.te_appstatus);
    setBusinessunitData(businessunitData);
    setBusinessunitData(item.te_buname);
    setBusinessunitName(item.te_buname);
    setDivisionName(item.te_divisionname);
    setEditDivisionId(item.te_divisionid);

    dispatch(applicationReducer.application_id(item.te_application_id));
    dispatch(applicationReducer.application_name(item.te_application_name));
    dispatch(applicationReducer.application_provider(item.te_app_provider));
    dispatch(
      applicationReducer.application_description(item.te_appdescription)
    );
    dispatch(applicationReducer.application_OS(item.te_appos));
    dispatch(applicationReducer.application_status(item.te_appstatus));
    dispatch(applicationReducer.application_bu(item.te_buname));
    dispatch(applicationReducer.application_division(item.te_divisionid));
    dispatch(applicationReducer.application_IsPane(true));
    dispatch(applicationReducer.application_filter(true));
  }

  // Cancel button function
  const onCancel = async () => {
    setApplicationName(application_name);
    setApplicationProvider(application_provider);
    setApplicationStatus(applicationstatus);
    setApplicationDescription(application_description);
    setApplicationOS(application_OS);
    setDivisionName(application_division);
    setBusinessunitName(application_bu);
    dispatch(applicationReducer.application_edit(false));
  };

  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line
  }, []);

  // for filtering
  const handleSearch = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    // dispatch(sidebarReducer.apiLoad(true));

    if (TargetColomn === "te_appstatus") {
      if (keyWord === "active") {
        keyWord = "1";
      } else if (keyWord === "inactive") {
        keyWord = "0";
      }
    }
    await axios
      .get(`applications/list?limit=${20}&${TargetColomn}=${keyWord}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setListApp(response.data.data.rows);
          setAppCount(response.data.data.count);
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);

          dispatch(applicationReducer.application_filter(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const handleReset = () => {
    // e.preventDefault();

    setAppFilter("");
    setAppselData("");
    setDummyAppfilter("");
    setDummyselData("");
    dispatch(applicationReducer.application_filter(true));
    responseData();
  };

  const handleReset1 = (e) => {
    setAppFilter("");
    setAppselData("");
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="Image container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "90vh" }}>
              {/** ROW 1 for header */}
              <div className="row g-0 p-0 border">
                <div className="col">
                  <div
                    className="g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>AR Application</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            {/* <button
                              className="btn"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "160px",
                              }}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(
                                    applicationReducer.addapplication_IsPane(
                                      true
                                    )
                                  );
                                  // dispatch(applicationReducer.application_filter(true));
                                  handleReset();
                                }
                              }}
                            >
                              <span
                                className="ToolTipB"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Application
                                <span
                                  className="ToolTipTextB"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add the Application."
                                    : "You cannot add the Applicationr."}
                                </span>
                              </span>
                            </button> */}
                          </div>
                          <div className="dropdown p-2">
                            {application_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(
                                  //   e,
                                  //   AppselData,
                                  //   AppFilter.toLowerCase()
                                  // );
                                  // settableheight(true);
                                  dispatch(
                                    applicationReducer.application_filter(false)
                                  );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "78px",
                                }}
                                onClick={() => {
                                  handleReset();
                                  // settableheight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0 ">
                <div className="col">
                  <div>
                    {!application_IsPane && !addapplication_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "red",
                                    height: "80px",
                                    paddingTop: "20px",
                                    paddingLeft: "50px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={AppFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setAppFilter(val);
                                      setDummyAppfilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={AppselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setAppselData(val);
                                        setDummyselData(val);
                                      }}
                                    >
                                      <MenuItem
                                        value="te_application_name"
                                        size="small"
                                      >
                                        Application Name
                                      </MenuItem>
                                      <MenuItem value="te_app_provider">
                                        Application Provider
                                      </MenuItem>
                                      <MenuItem value="te_appdescription">
                                        Application Description
                                      </MenuItem>
                                      <MenuItem value="te_appos">
                                        AppOS
                                      </MenuItem>
                                      <MenuItem value="te_buname">
                                        Business Unit
                                      </MenuItem>
                                      <MenuItem value="te_divisionname">
                                        Division
                                      </MenuItem>
                                      <MenuItem value="te_appstatus">
                                        Status
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                      // position: "relative",
                                      // top: "17px",
                                      // right: "-30px",
                                      // minWidth: "115px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(e, AppselData, AppFilter);
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      AppFilter.length > 0 &&
                                      AppselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      AppFilter.length > 0 &&
                                      AppselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!apiLoad ? (
                      <div
                        className="row AppCardMainp ps-3 pt-3"
                        style={{ overflowX: "hidden", overflowY: "auto" }}
                      >
                        {ListApp.length === 0 ? (
                          <h6
                            style={{ marginLeft: "500px", marginTop: "10px" }}
                          >
                            No Data Found
                          </h6>
                        ) : (
                          ListApp.map((item, index) => (
                            <div
                              className="card cardApp shadow col-md-6 col-sm-6 col-12 col-lg-4 col-xl-3 g-0"
                              key={index}
                              onClick={() => {
                                onEdit(item);
                                handleReset();
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                flexWrap: "wrap",
                                maxWidth: "255px",
                                minWidth: "244px",
                              }}
                            >
                              <div className="d-flex flex-row">
                                <div
                                  className="img rounded-start"
                                  style={{
                                    backgroundColor: "var(--themes-color)",
                                  }}
                                >
                                  <div className="AppCardHead text-white">
                                    <span className="ToolTipA">
                                      <strong>
                                        {item.te_application_name}
                                      </strong>
                                      <span className="ToolTipTextA">
                                        Application Name
                                      </span>
                                    </span>
                                    <img
                                      style={{
                                        position: "absolute",
                                        top: "4px",
                                        height: "40px",
                                        width: "40px",
                                        left: "10px ",

                                        // borderRadius: "25px",
                                      }}
                                      src={
                                        item.te_appos === "iOS"
                                          ? require("../../images/apple-logo-icon-14895.png")
                                          : item.te_appos === "Windows"
                                          ? require("../../images/Windows_logo_-_2012.svg.png")
                                          : item.te_appos === "Android"
                                          ? require("../../images/AndroidImg.png")
                                          : null
                                      }
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <div className="data rounded">
                                  <div className="AppCardBody">
                                    <span className="ToolTipA">
                                      {item.te_appstatus === "1" && (
                                        <div
                                          className="rounded-circle text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "20px",
                                            backgroundColor: "rgb(58,201,53)",
                                            top: "-15px",
                                            left: "-48px",
                                            height: "20px",
                                          }}
                                        ></div>
                                      )}
                                      {item.te_appstatus === "0" && (
                                        <div
                                          className="rounded-circle text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "20px",
                                            backgroundColor: "rgb(201,53,53)",
                                            top: "-15px",
                                            left: "-48px",
                                            height: "20px",
                                          }}
                                        ></div>
                                      )}
                                      <span className="ToolTipTextA">
                                        {item.te_appstatus === "0"
                                          ? "Inactive"
                                          : "Active"}
                                      </span>
                                    </span>
                                    <ul className="p-0">
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_buname}
                                          <span className="ToolTipTextA">
                                            Business Unit
                                          </span>
                                        </span>
                                      </li>
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_divisionname}
                                          <span className="ToolTipTextA">
                                            Division
                                          </span>
                                        </span>
                                      </li>
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_app_provider}
                                          <span className="ToolTipTextA">
                                            App Provider
                                          </span>
                                        </span>
                                      </li>

                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_appdescription}
                                          <span className="ToolTipTextA">
                                            App Description
                                          </span>
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "80vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinnerApi"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* pagination footer */}
            <div className="container">
              <div className="row main-footer">
                <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                  Total Records: {AppCount}
                </div>
                <div className="col-4 mt-2">
                  <div className="d-flex justify-content-center ">
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          leftEndArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== 1 && leftArrow();
                        }}
                      ></i>
                    </div>
                    <div
                      className={
                        noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                      }
                      style={
                        index1_pagenation === pageSelected ? onPage : notOnPage
                      }
                      onClick={() => {
                        pagenationAPi(index1_pagenation, AppselData, AppFilter);
                      }}
                    >
                      {index1_pagenation}
                    </div>
                    {noOfPages > 1 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index2_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index2_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index2_pagenation}
                      </div>
                    )}
                    {noOfPages > 2 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index3_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index3_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index3_pagenation}
                      </div>
                    )}
                    {noOfPages > 3 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index4_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index4_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index4_pagenation}
                      </div>
                    )}
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== noOfPages && rightArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          rightEndArrow();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-3 mt-2 ">
                  <div className="d-flex justify-content-end me-3">
                    <span>
                      <strong>Page {pageSelected} </strong> of{" "}
                      <strong>{noOfPages}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/** SlidingPan pop up for selecting and editing user data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="70%"
            hideHeader
            isOpen={application_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              setProductIdArr([]);
              setProductUnderApp([]);
              onCancel();
            }}
          >
            <div
              className="container-fluid "
              style={{ backgroundColor: "#f2f3f5", height: "50px" }}
            >
              <div className="row" style={{ height: "54px" }}>
                <div className="col-3">
                  <div className="d-flex align-items-center ">
                    <div
                      className="pt-1 me-2"
                      onClick={() => {
                        dispatch(applicationReducer.application_edit(false));
                        dispatch(
                          sidebarReducer.stringUpdate("ListApplication")
                        );
                        dispatch(applicationReducer.bu_edit(false));

                        dispatch(applicationReducer.application_IsPane(false));
                      }}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </div>
                    <div
                      className="border-start"
                      // className="px-2 pt-3 pb-1 border-secondary border-opacity-25 border-start"
                      style={{ height: "50px" }}
                    >
                      <h5 className="px-1 pt-3">
                        <strong>{application_name}</strong>
                      </h5>
                    </div>
                  </div>
                </div>

                <div className="col-9" style={{ height: "50px" }}>
                  <div
                    className="d-flex flex-row-reverse bd-highlight"
                    style={{ height: "50px" }}
                  >
                    <div
                      className="p-0 border-start"
                      // style={{ backgroundColor: "red" }}
                    >
                      {application_edit ? (
                        <button
                          className="button"
                          style={{
                            // paddingTop: "3px",
                            border: "none",
                            height: "50px",
                          }}
                          onClick={() => {
                            onUpdate(applicationId);
                          }}
                        >
                          <i className="bi bi-file-earmark-diff-fill"></i>
                          &nbsp;Save Changes
                        </button>
                      ) : (
                        <button
                          className="button"
                          style={{
                            zIndex: "1100",
                            // paddingTop: "3px",
                            border: "none",
                            height: "50px",
                          }}
                          onClick={() =>
                            Edit_Permission === 1 &&
                            dispatch(
                              applicationReducer.application_edit(
                                !application_edit
                              )
                            )
                          }
                        >
                          <span
                            className="ToolTipBEdit"
                            // style={{
                            //   backgroundColor: "var(--themes-color)",
                            // }}
                          >
                            <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                            Record
                            <span
                              className="ToolTipTextBEdit"
                              style={{
                                backgroundColor:
                                  Edit_Permission === 1
                                    ? "var(--themes-color)"
                                    : "red",
                              }}
                            >
                              {Edit_Permission === 1
                                ? "You can edit the Application."
                                : "You cannot edit the Application."}
                            </span>
                          </span>
                        </button>
                      )}
                    </div>
                    {application_edit && (
                      <div
                        className=" border-start "
                        style={{ height: "50px" }}
                        onClick={onCancel}
                      >
                        <button
                          className="button"
                          style={{
                            // paddingTop: "3px",
                            border: "none",
                            height: "50px",
                            minWidth: "85px",
                          }}
                        >
                          <i className="bi bi-arrow-clockwise"></i>&nbsp;Cancel
                          Changes
                        </button>
                      </div>
                    )}
                    <div className="p-0 border-start">
                      <button
                        className="button"
                        // data-bs-toggle="modal"
                        data-bs-target="#DeleteUser"
                        // data-backdrop="false"
                        style={{
                          zIndex: "1100",
                          border: "none",
                          height: "50px",
                          minWidth: "85px",
                        }}
                        onClick={() => {
                          Delete_Permission === 1 && setPopUp(true);
                        }}
                      >
                        <span
                          className="ToolTipBDelete"
                          style={
                            {
                              // backgroundColor:
                              //   "var(--themes-color)"
                            }
                          }
                        >
                          <i className="bi bi-trash-fill"></i>&nbsp; Delete
                          record
                          <span
                            className="ToolTipTextBDelete"
                            style={{
                              backgroundColor:
                                Delete_Permission === 1
                                  ? "var(--themes-color)"
                                  : "red",
                            }}
                          >
                            {Delete_Permission === 1
                              ? "You can delete the Application."
                              : "You cannot delete the Application."}
                          </span>
                        </span>
                      </button>
                    </div>
                    <div className="mode" style={{ padding: "12px" }}>
                      <div className="d-flex justify-content-center">
                        <i>
                          <strong style={{ color: "blue" }}>
                            {application_edit ? "Edit Mode" : "View Mode"}
                          </strong>
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row " style={{ width: "101.1%" }}>
              <div className="col ms-3 mt-2">
                {/* <h5>Basic information:</h5> */}
                <form style={{ width: "99%" }}>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      label="Name"
                      variant="outlined"
                      size="small"
                      value={applicationName}
                      onChange={(e) => setApplicationName(e.target.value)}
                      disabled={application_edit ? false : true}
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Provider"
                      variant="outlined"
                      size="small"
                      value={applicationProvider}
                      onChange={(e) => setApplicationProvider(e.target.value)}
                      disabled={application_edit ? false : true}
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Description"
                      variant="outlined"
                      size="small"
                      disabled={application_edit ? false : true}
                      value={appDescription}
                      onChange={(e) => {
                        console.log(appDescription, "desp");
                        setApplicationDescription(e.target.value);
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        OS
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        disabled={application_edit ? false : true}
                        label="inactiv"
                        variant="outlined"
                        value={appOS}
                        size="small"
                        onChange={(e) => {
                          let val = e.target.value;
                          setApplicationOS(val);
                        }}
                      >
                        <MenuItem value="Android">Android</MenuItem>
                        <MenuItem value="iOS">iOS</MenuItem>
                        <MenuItem value="Windows">Windows</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div
                    className="mb-3"
                    onMouseDown={() => {
                      if (application_edit) setApplicationStatus("Status");
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        disabled={application_edit ? false : true}
                        label="inactiv"
                        variant="outlined"
                        value={appStatus}
                        size="small"
                        onChange={(e) => {
                          let val = e.target.value;
                          setApplicationStatus(val);
                        }}
                      >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="0">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className="mb-3"
                    onMouseDown={() => {
                      if (application_edit)
                        setBusinessunitName("Business Unit");
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {businessunitName}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        // value={age}
                        disabled={application_edit ? false : true}
                        label="Business Unit"
                        variant="outlined"
                        onChange={(e) => {
                          dispatch(applicationReducer.bu_edit(true));
                          let val = e.target.value;
                          setBusinessunitData(e.target.value);
                          console.log(val, "val bu");
                          DivisionResponse(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.te_buid}
                            onClick={() => {
                              setBusinessunitName("Business Unit");
                            }}
                          >
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className="mb-3"
                    onMouseDown={() => {
                      if (application_edit && bu_edit)
                        setDivisionName("Division");
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {divisionName}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled={bu_edit ? false : true}
                        size="small"
                        label="Division"
                        variant="outlined"
                        onChange={(e) => {
                          axios
                            .get(
                              `masterproduct/listactive/${e.target.value}`,
                              options
                            )
                            .then((resp) => {
                              setProductAddValues(resp.data.data);
                            })
                            .catch((err) => console.log(err));
                          // setEditDisionData(e.target.value);
                          setEditDivisionId(e.target.value);
                          // setEditDisionData(e.target.value);
                          console.log(e.target.value, "val div");
                        }}
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.te_divisionid}
                            onClick={() => {
                              setDivisionName("Division");
                            }}
                          >
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        size="small"
                        required
                        style={{ backgroundColor: "white" }}
                      >
                        Products
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={productUnderApp}
                        input={<OutlinedInput label="Tag" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                        label="Products"
                        size="small"
                        variant="outlined"
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setProductUnderApp(
                            // On autofill we get a stringified value.
                            typeof value === "string" ? value.split(",") : value
                          );
                          const FilterArr = productAddValues.filter(
                            ({ te_productid, te_productname }) => {
                              return e.target.value.includes(te_productname);
                            }
                          );
                          const idArr = FilterArr.map(
                            ({ te_productid, te_productname }) => {
                              return te_productid;
                            }
                          );
                          setProductIdArr(idArr);
                        }}
                        disabled={bu_edit ? false : true}
                      >
                        {productAddValues.map((item, index) => (
                          <MenuItem key={index} value={item.te_productname}>
                            <Checkbox
                              checked={
                                productUnderApp.includes(item.te_productname)
                                  ? true
                                  : false
                              }
                            />
                            <ListItemText primary={item.te_productname} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>

          {/** SlidingPan pop up for adding new Application data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="68%"
            hideHeader
            isOpen={addapplication_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // onCancel();
              setProductIdArr([]);
              setProductUnderApp([]);
            }}
          >
            <div
              className="container-fluid m-0 g-0 border"
              style={{ backgroundColor: "#f2f3f5" }}
            >
              <div className="col-3">
                <div className="d-flex align-items-center flex-row">
                  <div
                    className="px-2 my-1"
                    onClick={() => {
                      dispatch(sidebarReducer.stringUpdate("ListApplication"));
                      dispatch(applicationReducer.addapplication_IsPane(false));
                      dispatch(applicationReducer.bu_edit(false));
                    }}
                  >
                    <i className="bi bi-arrow-right"></i>
                  </div>
                  <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                    <h5 style={{ whiteSpace: "nowrap" }}>
                      <strong>Add Application</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-9"></div>
            </div>

            <div className="row contentscroll" style={{ width: "101.5%" }}>
              <div className="col ms-3 mt-2">
                <form onSubmit={onAddapplication} style={{ width: "99%" }}>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      label="Name"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => setNewApplication(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Provider"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => setNewProvider(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      label="Description"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => setNewDescription(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        OS
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        label="inactiv"
                        variant="outlined"
                        size="small"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setAppOS(val);
                        }}
                      >
                        <MenuItem value={"Android"}>Android</MenuItem>
                        <MenuItem value={"iOS"}>iOS</MenuItem>
                        <MenuItem value={"Windows"}>Windows</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        label="inactive"
                        variant="outlined"
                        size="small"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setNewStatus(val);
                        }}
                      >
                        <MenuItem value={"1"}>Active</MenuItem>
                        <MenuItem value={"0"}>Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Business Unit
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Business Unit"
                        variant="outlined"
                        size="small"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          DivisionResponse(val);
                          dispatch(applicationReducer.bu_edit(true));
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Division
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Division"
                        size="small"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          axios
                            .get(
                              `masterproduct/listactive/${e.target.value}`,
                              options
                            )
                            .then((resp) => {
                              setProductAddValues(resp.data.data);
                            })
                            .catch((err) => console.log(err));
                          setNewDivisionId(e.target.value);
                        }}
                        // disabled={bu_edit ? false : true}
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        size="small"
                        required
                        style={{ backgroundColor: "white" }}
                      >
                        Products
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={productUnderApp}
                        input={<OutlinedInput label="Tag" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                        label="Products"
                        size="small"
                        variant="outlined"
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setProductUnderApp(
                            // On autofill we get a stringified value.
                            typeof value === "string" ? value.split(",") : value
                          );
                          const FilterArr = productAddValues.filter(
                            ({ te_productid, te_productname }) => {
                              return e.target.value.includes(te_productname);
                            }
                          );
                          const idArr = FilterArr.map(
                            ({ te_productid, te_productname }) => {
                              return te_productid;
                            }
                          );
                          setProductIdArr(idArr);
                        }}
                        disabled={bu_edit ? false : true}
                      >
                        {productAddValues.map((item, index) => (
                          <MenuItem key={index} value={item.te_productname}>
                            <Checkbox
                              checked={
                                productUnderApp.includes(item.te_productname)
                                  ? true
                                  : false
                              }
                            />
                            <ListItemText primary={item.te_productname} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-light text-white"
                      type="submit"
                      style={{ backgroundColor: "var(--themes-color)" }}
                    >
                      &nbsp;Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>Are you sure you want to delete this Application?</h6>
                </div>

                <div className="pt-4">
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    style={{
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                      onDelete(applicationId);
                    }}
                  >
                    Delete
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>

          {/* <div className="backdrop">
            <Backdrop
              sx={{
                color: "var(--themes-color)",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={apiLoad}
            //onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div> */}

          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
};
export default ListApplication;
